import { createSlice } from "@reduxjs/toolkit"
import { EARNINGS_STORE_NAME } from "../../../contants/stores";
import { EarningConfig } from '../types/earning.data';

interface EarningsState {
  defaultConfig: any,
  earningConfigs: EarningConfig[],
  allEarningConfigs: EarningConfig[],
  searchQuery: string,
  status: string,
  error: Error | undefined,
  currentPage: number,
  rowsPerPage: number,
  totalCount: number
}

export const initialState: EarningsState = {
  defaultConfig: {},
  earningConfigs: [],
  allEarningConfigs: [],
  searchQuery: '',
  status: 'idle',
  error: undefined,
  currentPage: 1,
  rowsPerPage: 10,
  totalCount: 0
}

export const slice = createSlice({
  name: EARNINGS_STORE_NAME,
  initialState,
  reducers: {
    setDefaultEarningConfig: (state, action) => {
      let earningConfig = {...action.payload};
      const { configs, apiKey, pricingInfoUrl, buyBonusConfig, ...config } = earningConfig;
      state.defaultConfig = {
        ...config,
        title: "",
      };
    },
    setEarningConfigs: (state, action) => {
      state.earningConfigs = action.payload.configs;
    },
    updateEarningConfigs: (state, action) => {
      state.earningConfigs = action.payload;
    },
    updateSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    setAllConfigs: (state, action) => {
      state.allEarningConfigs = action.payload;
    },
  },
});

export const actions = slice.actions
export const reducer = slice.reducer
